<template>
    <div>
        <!--<div-->
            <!--class="search&#45;&#45;icon">-->
            <!---->
            <!--<img src="/site/img/search_icon.svg" -->
            <!--alt="search icon">-->
        <!--</div>-->
        <div
            class="search__form search__form--open"
            :class="{
                'search__form--loading': state.loading,
                'search__form--has-results': showResults
                }">
            <div>
                <span class="search__form-icon">

                    <img src="/site/img/search_icon.svg" alt="search icon">
                </span>

                <input ref="searchField"
                    v-model="query"
                    type="search"
                    class="search__form-field">

                <img src="/site/img/search_loader.svg" alt="searching..." class="loading-animation">
            </div>
            <transition name="transition-all">
                <ul v-show="state.noResults" class="no-results">
                    <li>Geen resultaten</li>
                </ul>
            </transition>
            <transition name="transition-all">
                <ul v-if="state.result !== false && state.loading === false">
                    <li v-for="result in state.result.artworks"><a :href="result.url"><span>artwork</span> <img src="/site/img/arrow_3.svg" alt=""> {{ result.title }}</a></li>
                    <li v-for="result in state.result.pages"><a :href="result.url"><span>page</span> <img src="/site/img/arrow_3.svg" alt=""> {{ result.title }}</a></li>
                    <li v-for="result in state.result.news"><a :href="result.url"><span>news</span> <img src="/site/img/arrow_3.svg" alt=""> {{ result.title }}</a></li>
                </ul>
            </transition>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import debounce from 'lodash/debounce'

const locale = document.getElementsByTagName('html')[0].getAttribute('lang')

export default {

    data: function() {
        return {
            query: '',
            debouncedFetchResult: null,
            state: {
                searchInputOpened: true,
                noResults: false,
                loading: false,
                result: false
            }
        }
    },
    beforeMount: function() {
        this.debouncedFetchResult = debounce(this.fetchResult, 300)
    },
    methods: {
        fetchResult: function(query) {
            let self = this;
            axios.get('/api/v1/search?query=' + this.query + '&locale=' + locale)
                .then(self.handleResponse)
                .catch(self.applyErrorState)
        },
        handleResponse: function(response) {

            // Apply no results found state if response is empty and return
            if(this.checkResponseIsEmpty(response.data.results)) {
                this.applyNoResultState();
                return;
            } else {
                this.applyResultState();
            }

            // Fill results from response
            this.state.result = response.data.results;
            this.state.loading = false
        },

        checkResponseIsEmpty: function(results) {
            let isEmpty = true;
            for (var key in results) {
                if (results.hasOwnProperty(key)) {
                    if (results[key].length > 0) isEmpty = false
                }
            }
            return isEmpty;
        },
        applyNoResultState: function() {
            this.state.noResults = true
            this.state.loading = false
            this.state.result = false
        },
        applyResultState: function() {
            this.state.noResults = false
        },
        applyErrorState(error) {
            console.error(error);
            self.state.result = false
            self.state.loading = false
        }
    },
    watch: {
        query: function(query) {

            if (query === '') {
                document.getElementsByClassName("nav-menu")[0].classList.remove("wrapper-column-hide");
                this.applyNoResultState();
                return;
            } else {
                document.getElementsByClassName("nav-menu")[0].classList.add("wrapper-column-hide");
            }

            this.state.loading = true;
            this.debouncedFetchResult(query);
        }
    },
    computed: {
        hasResults: function() {
            return ( this.query !== '' && this.results !== false )
        },
        showResults: function() {
            return ( this.hasResults && this.state.searchInputOpened )
        }
    }
}
</script>


<style scoped>

.search__form-icon img{
    transform: scale(0.85);
}
.transition-all {
    backface-visibility: hidden;
    z-index: 1;
}

/* moving */
.transition-all-move {
    transition: all 200ms ease-in-out 50ms;
}

/* appearing */
.transition-all-enter-active {
    transition: all 200ms ease-out;
}

/* disappearing */
.transition-all-leave-active {
    transition: all 100ms ease-in;
    //position: absolute;
    z-index: 0;
}

/* appear at / disappear to */
.transition-all-enter,
.transition-all-leave-to {
    opacity: 0;
}
</style>




// WEBPACK FOOTER //
// resources/assets/js/site/components/search-widget/search-widget-root.vue